import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export const useCreatorStore = create(
  persist(
    set => ({
      channelId: undefined,
      setChannelId: channelId => set({ channelId }),
    }),
    {
      name: 'creator',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
